import { lazy, Suspense } from 'react';
import type { ComponentProps } from 'react';
import { CenterSpinner } from '@/components/ats';

// `react-pdf` + `@pdf-viewer/react` (~2.6 MB) are heavy and were loading eagerly
// in the main app bundle via PDFReader — downloaded on every page (even /jobs,
// with no PDF on screen). Lazy-load the implementation so the chunk is fetched
// only when a PDF actually renders. All consumers import these unchanged; the
// Suspense boundary lives here, so no caller needs its own.
//
// NOTE: props are typed off the lazy components (ComponentProps<typeof Lazy…>),
// NOT via `import type … from './PDFReader'`. A type-only import still creates a
// module edge that pulls PDFReader (and the pdf chunk) back into the eager
// graph, defeating the split.
const LazyPDFReader = lazy(() =>
  import('./PDFReader').then((m) => ({ default: m.PDFReader }))
);
const LazyPDFReaderBrowser = lazy(() =>
  import('./PDFReader').then((m) => ({ default: m.PDFReaderBrowser }))
);

export const PDFReader = (props: ComponentProps<typeof LazyPDFReader>) => (
  <Suspense fallback={<CenterSpinner />}>
    <LazyPDFReader {...props} />
  </Suspense>
);

export const PDFReaderBrowser = (
  props: ComponentProps<typeof LazyPDFReaderBrowser>
) => (
  <Suspense fallback={<CenterSpinner />}>
    <LazyPDFReaderBrowser {...props} />
  </Suspense>
);
